import { useEffect } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { TrustBar } from "@/components/site/TrustBar";
import { ClientsMarquee } from "@/components/site/ClientsMarquee";
import { NicheExpertise } from "@/components/site/NicheExpertise";
import { Services } from "@/components/site/Services";
import { WhyDigibis } from "@/components/site/WhyDigibis";
import { CaseStudies } from "@/components/site/CaseStudies";
import { Process } from "@/components/site/Process";
import { Testimonials } from "@/components/site/Testimonials";
import { CTASection } from "@/components/site/CTASection";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useEffect(() => {
    // Ensure dark theme on html for shadcn dark tokens
    document.documentElement.classList.add("dark");
  }, []);

  return (
    <div
      data-testid="landing-page"
      className="relative min-h-screen bg-[#121A12] text-[#F5F5F0]"
    >
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <ClientsMarquee />
        <NicheExpertise />
        <Services />
        <WhyDigibis />
        <CaseStudies />
        <Process />
        <Testimonials />
        <CTASection />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
